<script lang="ts">
  import BaseStep from "./BaseStep.svelte";
  import SharedHeading from "../SharedHeading.svelte";
  import { getCopy } from "../../lib/stores/copy";
  import Typography from "../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import { settingsStore } from "../../lib/stores/settings";

  type Rule = {
    url: string;
    description: string;
  };

  export let currentRoute;

  let rules = $settingsStore.rules as Rule[];

  if ($settingsStore.showFooterGDPR) {
    rules = rules?.filter((rule) => rule?.description?.trim().toLowerCase() !== "gdpr");
  }
  $: copy = $getCopy("rules") as Record<string, string>;
  // FIXME: rule names are not translatable
</script>

<BaseStep {currentRoute} customBackHandler={() => history.back()}>
  <svelte:fragment slot="content">
    <SharedHeading headerCopy={copy.headerCopy} subHeaderCopy={copy.subHeaderCopy} />
    <ul class="mt-4">
      {#if rules?.length > 0}
        {#each rules as rule}
          <li class="text-center lg:text-left mb-2">
            <Typography
              mobile={TypographyType.Body2Medium}
              desktop={TypographyType.Headline3Medium}
              --font-color="var(--color-grayscale-90)">
              <a href={rule.url} class="mb-8 text-center lg:text-left underline">
                {#if rule.description}
                  {rule.description}
                {:else}
                  {copy.defaultRuleName}
                {/if}
              </a>
            </Typography>
          </li>
        {/each}
      {:else}
        <li class="text-center lg:text-left">
          <p style="color: var(--color-grayscale-90)">{copy.noRulesConfiguredCopy}</p>
        </li>
      {/if}
    </ul>
    {#if copy.customHtml}
      <section class="custom-html">
        {@html copy.customHtml}
      </section>
    {/if}
  </svelte:fragment>
</BaseStep>
